document.addEventListener('DOMContentLoaded', () => {
  const addBtns = document.querySelectorAll(
    '.temp-product [data-add-btn]'
  );

  if (!addBtns.length) return;

  addBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();

      const mainCTA = document.querySelector(
        '.t4s-product-form__buttons .t4s-product-form__submit'
      );

      if (!mainCTA) {
        console.warn('Main CTA not found');
        return;
      }

      // Smooth scroll to main CTA
      mainCTA.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Trigger click AFTER scroll finishes
      setTimeout(() => {
        mainCTA.click();
      }, 600);
    });
  });
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.mix-add-btn')
  if (!btn) return

  e.preventDefault()

  if (btn.classList.contains('loading')) return

  btn.classList.add('loading')
  btn.disabled = true

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: btn.dataset.variantId,
        quantity: 1
      })
    })

    /* --------------------------------
       Notify UpCart / Apps
    -------------------------------- */
    document.dispatchEvent(new Event('cart:refresh'))
    document.dispatchEvent(new Event('cart:updated'))

  } catch (err) {
    console.error('Add to cart failed', err)
  }

  btn.classList.remove('loading')
  btn.disabled = false
})


